import "./UserAvatar.scss";
import md5 from "md5";

function UserAvatar({ user, size = "medium", className = "" }) {
  // Handle different user object structures
  const email = user?.email;
  const firstName = user?.firstName;
  const lastName = user?.lastName;
  const useGravatar = user?.profile?.useGravatar;
  const color = user?.profile?.color || "#2196f3";

  // Generate initials
  const initials = (() => {
    if (firstName && lastName) {
      return (
        firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
      );
    }
    if (firstName) {
      return firstName.charAt(0).toUpperCase();
    }
    return "?";
  })();

  // Generate Gravatar URL if needed
  const gravatarUrl =
    email && useGravatar
      ? `https://www.gravatar.com/avatar/${md5(email.toLowerCase().trim())}?s=200&d=mp`
      : null;

  return (
    <div className={`user-avatar ${size} ${className}`}>
      {gravatarUrl ? (
        <img
          src={gravatarUrl}
          alt={`${firstName} ${lastName}`}
          onError={(e) => {
            // If image fails to load, hide it and show initials
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
      ) : null}
      <div
        className="avatar-initials"
        style={{
          backgroundColor: color,
          display: gravatarUrl ? "none" : "flex",
        }}
      >
        {initials}
      </div>
    </div>
  );
}

export default UserAvatar;
